export default __webpack_public_path__ + "static/media/nodeJS.dd47e26e.svg";